import React, { useState } from "react";
import "./ElectricitySpendInput.css";

const ELECTRICITY_RATE = 0.2467;

export default function ElectricitySpendInput({ nextStep, updateFormData }) {
  const [useKWh, setUseKWh] = useState(false);
  const [value, setValue] = useState(0);

  const handleContinue = () => {
  if (value <= 0) {
    alert("Please enter a value greater than zero.");
    return;
  }

  // Convert monthly input to annual kWh
  const kWhValue = useKWh
    ? Math.round(value * 12) // kWh/month → annual
    : Math.round((value / ELECTRICITY_RATE) * 12); // £/month → kWh/year

  updateFormData({
    electricityInputMode: useKWh ? "kWh" : "money",
    electricityConsumption: kWhValue, // always annual kWh
  });

  nextStep();
};


  return (
    <div className="electricity-container">
      <div className="electricity-card">
        <h2>Your electricity usage</h2>
        <p className="intro-para">
          Tell us how much electricity you typically use. This helps us recommend the right system size and estimate your savings. You can enter your usage by money spent per month or electricity consumed per month.
        </p>

        <div className="switch-container">
          <label className="switch-label">£</label>
          <label className="switch">
            <input
              type="checkbox"
              checked={useKWh}
              onChange={() => {
                setUseKWh(!useKWh);
                setValue(0); // reset on toggle
              }}
            />
            <span className="slider-round" />
          </label>
          <label className="switch-label">kWh</label>
        </div>

        <div className="slider-block">
          <label className="slider-title">
            {useKWh ? "Electricity consumed per month" : "Money spent per month"}
          </label>
          <input
            type="range"
            min="0"
            max={useKWh ? 2000 : 500}
            value={value}
            onChange={(e) => setValue(Number(e.target.value))}
          />
          <p className="value-display">
            {useKWh
              ? `${value.toLocaleString()} kWh`
              : `£${value.toLocaleString()}`}
          </p>
        </div>

        <button className="continue-button" onClick={handleContinue}>
          Continue
        </button>
      </div>
    </div>
  );
}
